import Constants from '@Apis/constants';
import Helpers from '@Apis/helpers';
import axios from 'axios';

/**
 * @param mapPendingAction
 * @param actionType
 * @param page
 * @param limit
 * @param payload
 */
class UserServices {
  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  requestOtp = async (payload) => {
    const otpResponse = await Helpers.post({
      url: Constants.REQUEST_OTP,
      data: payload,
      customHeaders: {
        client_type: 'CUSTOMER',
      },
    });
    return otpResponse;
  }

  /**
   * @return
   * @param page
   * @param orgId
   * @param tenantId
   * @param limit
   */
  getUsers = async (page, orgId, tenantId, limit) => {
    let url = `${Constants.TENANT_USERS}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (orgId) url += `org_id=${orgId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    const users = Helpers.get({ url });
    return users;
  }

  /**
   * @return
   * @param page
   * @param orgId
   * @param tenantDepartmentId
   * @param tenantId
   */
     getRoles = async (tenantId, tenantDepartmentId) => {
       let url = `${Constants.TENANT_ROLES}?`;
       if (tenantId) url += `tenant_id=${tenantId}&`;
       if (tenantDepartmentId) url += `tenant_department_id=${tenantDepartmentId}&`;
       const users = Helpers.get({ url });
       return users;
     }

  /**
   *
   * @param {*} payload
   * @return
   */
  createUser = async (payload) => {
    const createdUser = await Helpers.post({
      url: Constants.TENANT_USERS,
      data: payload,
    });
    return createdUser;
  }

  /**
   * @param {*} page
   * @param tenantId
   * @param roleId
   * @return
   */
  getPermissions = async (page, tenantId, roleId) => {
    const getPermissions = Helpers.get({
      url: `${Constants.GET_PERMISSIONS}${page ? `?page=${page}` : ''}${tenantId ? `&tenant_id=${tenantId}` : ''}${roleId ? `&role_id=${roleId}` : ''}`,
    });
    return getPermissions;
  }

  /**
   * @return {Promise<void>}
   * @param payload
   */
  initPermissions = async (payload) => {
    const initPermissions = Helpers.post({
      url: Constants.INIT_PERMISSION,
      data: payload,
    });
    return initPermissions;
  };

  /**
   *
   * @param {*} payload
   * @return
   */
  updateRole = async (payload) => {
    const updateRole = await Helpers.put({
      url: Constants.UPDATE_PERMISSION,
      data: payload,
    });
    return updateRole;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createRole = async (payload) => {
    const createdRole = await Helpers.post({
      url: Constants.CREATE_PERMISSION,
      data: payload,
    });
    return createdRole;
  }

  /**
   * @param payload
   * @return {Promise<*>}
   */
   updateUser = async (payload) => {
     const updatedUser = await Helpers.put({
       url: Constants.TENANT_USERS,
       data: payload,
     });
     return updatedUser;
   }

   /**
    * @param payload
    * @return {Promise<*>}
    */
    updateMyUser = async (payload) => {
      const updateMyUser = await Helpers.put({
        url: Constants.MY_USER,
        data: payload,
      });
      return updateMyUser;
    }

    /**
     * @param payload
     * @return {Promise<*>}
     */
  verifyOtp = async (payload) => {
    const verifiedUser = await Helpers.post({
      url: Constants.VERIFY_OTP,
      data: payload,
    });
    return verifiedUser;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  resendOtp = async (payload) => {
    const resendOtpResponse = await Helpers.post({
      url: Constants.RESEND_OTP,
      data: payload,
    });
    return resendOtpResponse;
  }

  /**
   *
   * @param files
   * @return {Promise<unknown>}
   */
  uploadFile = (files) => new Promise(((resolve, reject) => {
    const uploadPromises = [];
    files.forEach((file) => {
      const formData = new FormData();
      formData.append('file', file);
      uploadPromises.push(Helpers.filePost({
        url: Constants.UPLOAD_IMAGE,
        file: formData,
      }));
    });
    Promise.all(uploadPromises).then((uploadedFiles) => {
      resolve(uploadedFiles);
    }).catch((error) => {
      reject(error.message);
    });
  }))

  /**
   * @return {Promise<unknown>}
   * @param tenantId
   */
  getUserProfile = async (tenantId) => {
    const profile = Helpers.get({
      // url: `${Constants.GET_USER_PROFILE}`,
      url: `${Constants.GET_USER_PROFILE}${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return profile;
  }

  /**
   *
   * @param payload
   * @return {Promise<void>}
   */
  signupUser = async (payload) => {
    const signupResponse = Helpers.post({
      url: Constants.SIGNUP_USER,
      data: payload,
    });
    return signupResponse;
  }

  /**
   *
   * @param payload
   * @return {Promise<unknown>}
   */
  verifySignupOtp = async (payload) => {
    const verifyOtpResponse = Helpers.post({
      url: Constants.VERIFY_SIGNUP_OTP,
      data: payload,
    });
    return verifyOtpResponse;
  }

  /**
   *
   * @param payload
   * @return {Promise<unknown>}
   */
  requestCallback = (payload) => new Promise(((resolve, reject) => {
    axios.post('https://h3-helper-servicces.herokuapp.com/api/v1/mail/send', payload).then((respose) => {
      resolve(respose.data);
    }).catch((err) => reject(err));
  }))

  /**
   * @param payload
   * @return {Promise<*>}
   */
   updateOrg = async (payload) => {
     const updateOrg = await Helpers.put({
       url: Constants.ORGANISATION,
       data: payload,
     });
     return updateOrg;
   }

   /**
    * @return {Promise<unknown>}
    * @param orgId
    * @param tenantId
    */
    getOrg = async (orgId) => {
      const profile = Helpers.get({
        url: `${Constants.ORGANISATION}${orgId ? `?org_id=${orgId}` : ''}`,
      });
      return profile;
    }

  /**
   *
   * @param mapPendingAction
   * @param actionType
   * @param page
   * @param limit
   * @return {Promise}
   */
  getPendingActions = async (mapPendingAction, actionType, page, limit) => {
    let url = `${Constants.PENDING_ACTIONS}?`;
    if (mapPendingAction) url += `${actionType}=true&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}`;
    const pendingActions = Helpers.get({
      url,
    });
    return pendingActions;
  }
}

export default new UserServices();
